export const FETCH_HANDLER_PROFILE_REQUEST = 'FETCH_HANDLER_PROFILE_REQUEST';
export const FETCH_HANDLER_PROFILE_SUCCESS = 'FETCH_HANDLER_PROFILE_SUCCESS';
export const FETCH_HANDLER_PROFILE_FAILURE = 'FETCH_HANDLER_PROFILE_FAILURE';
export const CHECK_HANDLER_PROFILE = 'CHECK_HANDLER_PROFILE';
export const PATCH_HANDLER_REQUEST = 'PATCH_HANDLER_REQUEST';
export const PATCH_HANDLER_SUCCESS = 'PATCH_HANDLER_SUCCESS';
export const PATCH_HANDLER_FAILURE = 'PATCH_HANDLER_FAILURE';